import React, { Component } from 'react';
import "./servicios.css";
import _ from "lodash";

class Servicios extends Component {
    renderServices(services){
        return _.map(services, service =>{
            return (
                <div key={service.id} className="servicios-item">
                    <div className="servicios-item-image">
                        <img src={service.icon.src} alt={service.icon.alt}/>
                    </div>
                    <div className="servicios-item-title raleway fw-bold">
                        <h2>{service.title}</h2>
                        <div className="servicios-item-title-line"/>
                    </div>
                    <div className="servicios-item-description raleway fw-regular">
                        {service.description}
                    </div>
                </div>
            )
        });
    }

    render() {
        return (
            <div className="servicios">
                <div className={`section-title montserrat fw-bold ${this.props.visible ? "animated fadeInUp" : "opa-0"}`}>
                    <h2>Servicios</h2>
                    <div className="section-title-line"/>
                </div>
                <div className="servicios-content">
                    {this.renderServices(this.props.content)}
                </div>
            </div>
        );
    }
}

export default Servicios;


// WEBPACK FOOTER //
// ./src/sections/Servicios.js